import {autocompleteClasses, outlinedInputClasses, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiAutocomplete = ({inputfield, autocomplete, focus}: Tokens): ThemeOptions['components'] => {
  const {container} = inputfield;

  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiFormControl-marginNormal': {
            marginTop: 0,
            marginBottom: 8
          },
          [`& .${outlinedInputClasses.root}`]: {
            [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon}&`]: {
              paddingRight: 0
            }
          }
        },
        popupIndicatorOpen: {
          transform: 'none'
        },
        listbox: {
          [`& .${autocompleteClasses.option}`]: {
            [`&.${autocompleteClasses.focused}`]: {
              backgroundColor: autocomplete.desktop.unselected.hover.background.color,
              color: autocomplete.desktop.unselected.hover.font.color
            },
            '&.Mui-focusVisible': {
              backgroundColor: autocomplete.desktop.unselected.focus.background.color,
              color: autocomplete.desktop.unselected.focus.font.color,
              outline: `${focus.outline.width} ${focus.outline.style} ${focus.outline.color}`,
              outlineOffset: '-2px'
            },
            '&[aria-selected="true"]': {
              backgroundColor: autocomplete.desktop.selected.background.color,
              color: autocomplete.desktop.selected.font.color,
              [`&.${autocompleteClasses.focused}`]: {
                backgroundColor: autocomplete.desktop.selected.background.color,
                color: autocomplete.desktop.selected.font.color,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                  backgroundColor: 'transparent'
                }
              },
              '&.Mui-focusVisible': {
                backgroundColor: autocomplete.desktop.selected.focus.background.color,
                color: autocomplete.desktop.selected.focus.font.color,
                outline: `${focus.outline.width} ${focus.outline.style} ${focus.outline.color}`,
                outlineOffset: '-2px'
              }
            }
          }
        },
        inputRoot: {
          '&[class*="MuiOutlinedInput-root"]': {
            padding: 0,
            backgroundColor: container.desktop.background.color,
            '& .MuiAutocomplete-input': {
              padding: `${container.desktop.padding.top} ${container.desktop.padding.right} ${container.desktop.padding.bottom} ${container.desktop.padding.left}`
            },
            [`.${autocompleteClasses.hasPopupIcon} &, .${autocompleteClasses.hasClearIcon} &`]: {
              paddingRight: 0
            },
            [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon} &`]: {
              paddingRight: 0
            },
            [`& .${autocompleteClasses.input}`]: {
              padding: `${container.desktop.padding.top} ${container.desktop.padding.right} ${container.desktop.padding.bottom} ${container.desktop.padding.left}`
            },
            [`& .${autocompleteClasses.input}:first-of-type`]: {
              paddingLeft: container.desktop.padding.left
            },
            [`& .${autocompleteClasses.endAdornment}`]: {
              right: container.desktop.padding.right
            }
          }
        }
      }
    }
  };
};
